"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.providers = void 0;
var providers;
(function (providers) {
    providers["PCI"] = "pci";
    providers["PRECISION"] = "precision";
    providers["GEMCO"] = "gemco";
    providers["SPIRE"] = "spire";
    providers["BELUGA"] = "beluga";
    providers["FRESH_DESK"] = "freshDesk";
})(providers || (exports.providers = providers = {}));
